import {
  HStack,
  VStack,
  Text,
  Button,
  useColorModeValue,
  Image,
  Stack,
} from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'
import { ContainerBase } from './containers/ContainerBase'

interface PageHeroProps {
  title: string
  subTitle: string
  description: string
  image: string
  anchor: string
  mobileImage?: string
}

export const PageHero = ({
  title,
  subTitle,
  description,
  image,
  anchor,
  mobileImage,
}: PageHeroProps) => {
  const t = useTranslations()
  const router = useRouter()
  const borderColor = useColorModeValue('black', 'white')

  const handleScroll = () => {
    const section = document.getElementById(anchor)
    section?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  return (
    <ContainerBase
      py={{ base: 0, lg: '64px' }}
      px={0}
      maxW={{ base: 'container.lg', xl: 'container.xl', xxl: 'container.xxl' }}
    >
      <Stack
        direction={{ base: 'column', lg: 'row' }}
        justify="space-between"
        align="center"
      >
        <VStack align="start" gap="16px" py={{ base: '32px', lg: 0 }}>
          <Text fontSize={{ base: '16px', md: '24px' }} fontWeight="600">
            {subTitle}
          </Text>
          <Text
            fontSize={{ base: '40px', md: '64px' }}
            fontWeight="300"
            fontFamily="Space Grotesk"
            maxW={{ base: '364px', md: '592px' }}
            lineHeight="normal"
          >
            {title}
          </Text>
          <Text
            fontSize={{ base: '16px', md: '24px' }}
            maxW={{ base: '350px', md: '592px' }}
          >
            {description}
          </Text>
          <HStack gap="16px">
            <Button
              variant="brandGradient"
              h="48px"
              px="24px"
              maxW="288px"
              w="full"
              fontSize={{ base: '16px', md: '18px' }}
              onClick={() => router.push('hardware')}
            >
              {t('hosting-orders.buy-hosted-miners')}
            </Button>
            <Button
              variant="outline"
              h="48px"
              maxW="120px"
              w="full"
              borderColor={borderColor}
              fontSize={{ base: '16px', md: '18px' }}
              onClick={handleScroll}
            >
              {t('buttons.learn-more')}
            </Button>
          </HStack>
        </VStack>
        {mobileImage && (
          <Image
            alt="hero-image"
            src={mobileImage}
            display={{ base: 'block', lg: 'none' }}
            w="full"
          />
        )}
        <Image
          alt="hero-image"
          src={image}
          display={mobileImage ? { base: 'none', lg: 'block' } : 'block'}
        />
      </Stack>
    </ContainerBase>
  )
}
